import { useFormContext } from 'react-hook-form';

import { ControlledCheckbox } from 'components/shared/ControlledFields';
import MultiStepForm from 'components/shared/MultiStepForm/MultiStepForm';
import i18n from 'config/i18n';
import { getLocale } from 'utils/date';
import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';
import InputAdornment from '@mui/material/InputAdornment';

const t = i18n.getFixedT(getLocale(), 'common');

const AbsenceFormContent = () => {
  const { control } = useFormContext();

  return (
    <>
      <MultiStepForm.Section title={t('absenceProcedure.title')}>
        <ControlledNumericField
          name="absence_minmax_contract_fte"
          label={t('absenceProcedure.minMaxContract')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                {t('absenceProcedure.fte')}
              </InputAdornment>
            )
          }}
        />
        <ControlledNumericField
          name="absence_hours_contract_fte"
          label={t('absenceProcedure.hoursContract')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                {t('absenceProcedure.fte')}
              </InputAdornment>
            )
          }}
        />
        <ControlledNumericField
          name="absence_zero_hours_contract_fte"
          label={t('absenceProcedure.zeroHoursContract')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                {t('absenceProcedure.fte')}
              </InputAdornment>
            )
          }}
        />
      </MultiStepForm.Section>
      <MultiStepForm.Section title={t('absenceProcedure.changeHoursToAbsence')}>
        <ControlledCheckbox
          control={control}
          name="absence_dcc_5_not_halve"
          label={t('absenceProcedure.dcc_5_nor_halve')}
        />
        <ControlledCheckbox
          control={control}
          name="absence_dcc_7_ill"
          label={t('absenceProcedure.absence_dcc_7_ill')}
        />
        <ControlledCheckbox
          control={control}
          name="absence_dcc_18_ill"
          label={t('absenceProcedure.absence_dcc_18_ill')}
        />
      </MultiStepForm.Section>
    </>
  );
};

export default AbsenceFormContent;
